<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="Youtube">
      <g id="Icon-7" data-name="Icon">
        <path
          d="M19.437,19.936H4.563a2.5,2.5,0,0,1-2.5-2.5V6.564a2.5,2.5,0,0,1,2.5-2.5H19.437a2.5,2.5,0,0,1,2.5,2.5V17.436A2.5,2.5,0,0,1,19.437,19.936ZM4.563,5.064a1.5,1.5,0,0,0-1.5,1.5V17.436a1.5,1.5,0,0,0,1.5,1.5H19.437a1.5,1.5,0,0,0,1.5-1.5V6.564a1.5,1.5,0,0,0-1.5-1.5Z"
        />
        <path
          d="M14.568,11.149,10.6,8.432a1.032,1.032,0,0,0-1.614.851v5.434a1.032,1.032,0,0,0,1.614.851l3.972-2.717A1.031,1.031,0,0,0,14.568,11.149Z"
        />
      </g>
    </g>
  </svg>
</template>
